<template lang="pug">
ValidationProvider(:name="name" :rules="rules")
  .form(slot-scope="{ errors }")
    label.form-label {{ label }}
    Multiselect(v-bind="$attrs" :label="labelBy" v-on="$listeners" v-model="innerValue")
    transition(name="validation")
      p(v-if="errors[0]").form-error {{ errors[0] }}
</template>

<script>
import { ValidationProvider } from 'vee-validate/dist/vee-validate.minimal';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'SelectInput',
  components: {
    Multiselect,
    ValidationProvider
  },
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    rules: {
      type: [String, Object],
      default: ''
    },
    value: {
      type: null,
      default: () => []
    },
    labelBy: {
      type: String,
      default: ''
    }
  },
  data: vm => ({
    innerValue: vm.value
  }),
  watch: {
    value(val) {
      this.innerValue = val;
    }
  }
};
</script>
